import { DossierFinancementDecisionType, DossierFinancementEventType, } from '../types';
/**
 * Dossiers financement service
 */
class DossiersFinancementService {
    /**
     * Get active decisions for ligne in Plan Financement
     */
    getActiveDecisions(ligne) {
        const decisionOrClotureEvents = ligne.financement?.history?.events?.filter(({ type }) => [DossierFinancementEventType.DECISION, DossierFinancementEventType.CLOTURE].includes(type)) ?? [];
        const result = [];
        for (let i = 0; i < decisionOrClotureEvents.length; i++) {
            const event = decisionOrClotureEvents[i];
            if (event &&
                event.type === DossierFinancementEventType.DECISION &&
                (!decisionOrClotureEvents[i + 1] ||
                    decisionOrClotureEvents[i + 1]?.type !== DossierFinancementEventType.CLOTURE)) {
                result.push(event);
            }
        }
        return result;
    }
    /**
     * Get active decisions for V8 dossiers
     */
    getActiveDecisionsV8(events) {
        let sortedEvents = events;
        if (sortedEvents.every((event) => event.date != null)) {
            sortedEvents = sortedEvents.sort((a, b) => +new Date(a.date ?? Date.now()) - +new Date(b.date ?? Date.now()));
        }
        const lastEvents = {};
        // We keep only the last event of the same reference
        for (const event of sortedEvents) {
            if (event.reference) {
                lastEvents[event.reference] = event;
            }
        }
        // We are interested in the decision that are favorable or defavorable
        const filteredEvents = Object.values(lastEvents).filter((event) => event.type === 'DECISION' && (event.avis === 'FAVORABLE' || event.avis === 'DEFAVORABLE'));
        return filteredEvents;
    }
    /**
     * test if aide ligne fictive have at least one non CLOTURE DECISION favorable in v8 dossiers
     */
    isAideHaveAtLeastOneActiveDecisionFavorableV8(aideLigneFictive) {
        if (!aideLigneFictive)
            throw new Error('[isAideHaveAtLeastOneActiveDecisionFavorableV8] - Missing aide param');
        const events = aideLigneFictive.financement?.history?.events ?? [];
        const validDecisions = this.getActiveDecisionsV8(events);
        return validDecisions.some(({ avis }) => avis === DossierFinancementDecisionType.FAVORABLE);
    }
    /**
     * test if aide ligne fictive have at least one non CLOTURE DECISION favorable
     */
    isAideHaveAtLeastOneActiveDecisionFavorable(aideLigneFictive) {
        if (!aideLigneFictive)
            throw new Error('[isAideHaveAtLeastOneActiveDecisionFavorable] - Missing aide param');
        const validDecisions = this.getActiveDecisions(aideLigneFictive);
        return validDecisions.some(({ avis }) => avis === DossierFinancementDecisionType.FAVORABLE);
    }
}
export { DossiersFinancementService };
//# sourceMappingURL=dossiers-financement-service.js.map